import { Divider } from "primereact/divider";
import { Tooltip } from "primereact/tooltip";

export default function ScansRow(props) {
  const { title, values, bgColor } = props;
  return (
    <div
      className="card flex align-items-center mb-3"
      style={{
        // backgroundColor: bgColor,
        height: 40,
        width: "100%",
        padding: "1rem",
      }}
    >
      <div className="rounded-l" style={{ border: `3px solid ${bgColor}`, position: 'absolute', left: '20px', height: '40px' }} /> 
      <div
        style={{
          width: "14%",
        }}
      >
        <label className="text-sm font-bold flex">{title}</label>
      </div>
      {values.map((value) => {
        const { key, count, time } = value;
        return (
          <div
            key={key}
            className="flex justify-content-between align-items-center"
            style={{
              width: "27%",
            }}
          >
            <div
              className="flex align-items-center"
              style={{
                marginLeft: "10px",
              }}
            >
              {/* <span
                style={{
                  height: 40,
                  width: '1px',
                  backgroundColor: "#B6D4F1",
                  marginRight: "10px",
                }}
              /> */}
              <Divider layout="vertical" />
            </div>
            <Tooltip target=".patient-tip" />
            <Tooltip target=".avg-time-tip" />
            <div className="flex flex-column align-items-center">
              <label className="patient-tip" data-pr-tooltip="Total patients count">{count}</label>
              <Divider className="m-0"/>
              <label className="font-bold avg-time-tip" data-pr-tooltip="Total avg time">{time}</label>
            </div>
          </div>
        );
      })}
    </div>
  );
}
